<template>
  <el-container class="justify-content-center">
    <el-header id="header">
      <PlatformHeader />
    </el-header>
    <el-main id="main">
      <Default v-show="isProcessing" />
      <router-view v-show="!isProcessing"/>
    </el-main>
  </el-container>
</template>

<script>
import PlatformHeader from "@/components/Header.vue";
import Default from "@/components/Default";
import { mapGetters } from 'vuex';

export default {
  name: "App",
  components: {
    PlatformHeader,
    Default,
  },
  computed: {
    ...mapGetters([
      'isProcessing',
    ]),
  },
};
</script>

<style scoped>
#main {
  padding: 0;
  height: 90vh;
}

#header {
  height: 10vh;
  padding: 0;
}

</style>
